import { headUrl } from '@/config/base.js';
import PersonalDrinks1 from '@/images/personal-drinks-1.jpg';
import PersonalDrinks2 from '@/images/personal-drinks-2.jpg';
import PersonalDrinks3 from '@/images/personal-drinks-3.jpg';
import Enterprise1 from '@/images/enterprise-1.jpg';
import Enterprise2 from '@/images/enterprise-2.jpg';
import Enterprise3 from '@/images/enterprise-3.jpg';
import Offline1 from '@/images/offline-1.jpg';
import Offline2 from '@/images/offline-2.jpg';
import Offline3 from '@/images/offline-3.jpg';
import Case1 from '@/images/case-1.jpg';
import Case2 from '@/images/case-2.jpg';
import Case3 from '@/images/case-3.jpg';
import Case4 from '@/images/case-4.jpg';
import Case5 from '@/images/case-5.jpg';
import Case6 from '@/images/case-6.jpg';

export const customize_purpose = [
  {
    title: '员工福利',
    desc: '年会礼品，节日礼物，活动奖品'
  },
  {
    title: '商务送礼',
    desc: '商务会晤馈赠，大型活动赠品'
  },
  {
    title: '私人定制',
    desc: '婚宴伴手礼，同学会礼品'
  },
]

export const space_customize_purpose = [
  {
    title: '一站式服务',
    desc: '附赠茶具的搭配方案'
  },
  {
    title: '理解茶文化',
    desc: '源自茶企的茶具品牌'
  },
  {
    title: '茶人设计师',
    desc: '兼顾美学与茶氛围塑造'
  },
  {
    title: '个性化定制',
    desc: '不限空间遵循实用原则'
  },
]

export const flow = [
  {
    key: 1,
    title: '选款'
  },
  {
    key: 2,
    title: '定稿'
  },
  {
    key: 3,
    title: '下单'
  },
  {
    key: 4,
    title: '制作'
  },
  {
    key: 5,
    title: '发货'
  },
  {
    key: 6,
    title: '完成'
  },
];

export const space_flow = [
  {
    key: 1,
    title: '在线咨询'
  },
  {
    key: 2,
    title: '意向确认'
  },
  {
    key: 3,
    title: '需求确认'
  },
  {
    key: 4,
    title: '设计报价'
  },
  {
    key: 5,
    title: '确认工期'
  },
  {
    key: 6,
    title: '定制结算'
  },
  {
    key: 7,
    title: '项目验收'
  },
  {
    key: 8,
    title: '售后服务'
  },
];

export const recommendProducts = [
  {
    title: "恒温杯垫",
    pic: "/images/customization/recommend_1.png"
  },
  {
    title: "茶具礼盒",
    pic: "/images/customization/recommend_2.png"
  },
  {
    title: "玻璃茶杯",
    pic: "/images/customization/recommend_3.png"
  },
  {
    title: "玻璃茶壶",
    pic: "/images/customization/recommend_4.png"
  },
];


export const brandIntroTypes = [
  {
    key: 1,
    title: "材质",
    desc: '追寻茶味本源',
    introduction: '茶性不同，适合的器型各异，所用材质也有差别。 为还原茶的本味，雅集严选茶具材质。'
  },
  {
    key: 2,
    title: "工艺",
    desc: '有温度的手作',
    introduction: '雅集匠人对手作茶具的要求，使作品较工业化产品多了份温度和情感，让使用变得愉悦。'
  },
  {
    key: 3,
    title: "设计",
    desc: '痴于茶的设计',
    introduction: '雅集尚简，注重产品的使用感。作为茶艺师产品团队，雅集让泡茶变成一种生活美学。'
  },
  {
    key: 4,
    title: "包装",
    desc: '走心的轻设计',
    introduction: '雅集包装可反复使用，经过对结构的设计减少了塑料及气泡垫的使用，保护产品，有益环境。'
  },
  {
    key: 5,
    title: "服务",
    desc: '私享茶学顾问',
    introduction: '雅集服务顾问为茶学领域从业者，为您提供好用的茶与茶具的搭配方案，购物体验舒适。'
  },
]

export const cultures = [
  {
    title: '雅集景愿',
    image: '/images/culture/culture_1.png',
    desc: '泡出“真”茶韵\n成为综合性的茶具服务商\n提供茶饮一站式冲泡方案（平台',
    intro: '雅集自2009年创办以来，始终秉承着还原茶叶最佳韵味的初心，致力于为各类茶叶定制原创冲泡器具，以形成一整套的茶饮冲泡方案。截至2019年7月，雅集已拥有230件商标和23款专利产品。'
  },
  {
    title: '雅集使命',
    image: '/images/culture/culture_2.png',
    desc: '中国茶文化的传播者\n让更多人爱上茶的味道',
    intro: '茶是雅文化的一扇窗口，茶中沉淀的文化底蕴，更是中国最具代表性的名片之一。雅集以传播中国茶文化为使命，借助为茶设计美物的契机，不断简化泡茶步骤，从而把中国茶从繁琐的仪式中解放出来，更好地适应快节奏的生活方式。'
  },
];

export const values = [
  {
    title: '追求极致',
    desc: '雅集持续改进材质、工艺、设计、包装、服务等细节，让用户在入手时就能感受到我们的用心。',
    img: '/images/culture/value_1.png'
  },
  {
    title: '开拓创新',
    desc: '努力优化传统的泡茶方式，争取用最简单的步骤泡出茶叶最美好的味道。',
    img: '/images/culture/value_2.png'
  },
  {
    title: '笃行务实',
    desc: '以谦卑心造物，戒除娇奢浮躁，踏踏实实地将茶器做到“十分”，对得起顾客每分钱的付出。',
    img: '/images/culture/value_3.png'
  },
];

export const news = [
  {
    title: '拒绝雾霾 雅集在行动！',
    img: '/images/dynamic/dynamic.png',
    create_time: '2019年09月20日',
    desc: '——雅集产品义卖会 邀您一起【抗霾】从点滴做起'
  },
  {
    title: '拒绝雾霾 雅集在行动！',
    img: '/images/dynamic/dynamic.png',
    create_time: '2019年09月20日',
    desc: '——雅集产品义卖会 邀您一起【抗霾】从点滴做起'
  },
];

export const contactInfo = [
  {
    key: 1,
    title: '电话热线',
    value: '0571-86551555'
  },
  {
    key: 2,
    title: '电子邮箱',
    value: 'yaji@yaji365.com'
  },
  {
    key: 3,
    title: '微博',
    value: '雅集茶具'
  },
  {
    key: 4,
    title: '微信',
    value: '雅集茶具（YajiGlass）'
  },
  {
    key: 5,
    title: '公司地址',
    value: '浙江省杭州市滨江区长河街道长河路1318号博风创意大厦1幢2303室'
  },
];

export const products = [
  {
    key: 1,
    name: '直觉杯'
  },
  {
    key: 2,
    name: '自然数杯'
  },
  {
    key: 3,
    name: '圆趣杯'
  },
  {
    key: 4,
    name: '小熊杯'
  },
  {
    key: 5,
    name: '窈窕杯'
  },
  {
    key: 6,
    name: '直觉杯'
  },
  {
    key: 7,
    name: '颜品杯'
  },
  {
    key: 8,
    name: '公道杯'
  },
  {
    key: 9,
    name: '锤纹公道杯'
  },
  {
    key: 10,
    name: '儒隐骨瓷盖碗'
  },
  {
    key: 11,
    name: '锤纹盖碗'
  },
  {
    key: 12,
    name: '沉玺锤纹壶'
  }
]

export const videos = [
  {
    key: 1,
    title: '品牌视频',
    desc: '雅集茶美物',
    video: headUrl + "/static/yaji/yaji_company_3.mp4",
    poster: '/images/vedio/vedio.png'
  },
  {
    key: 2,
    title: '品牌视频',
    desc: '雅集茶美物',
    video: headUrl + "/static/yaji/yaji_company_1.mp4",
    poster: '/images/vedio/vedio.png'
  },
  {
    key: 3,
    title: '品牌视频',
    desc: '雅集茶美物',
    video: headUrl + "/static/yaji/yaji_company_2.m4v",
    poster: '/images/vedio/vedio.png'
  },
];

export const developmentData = [
  {
    key: 1,
    time: '2018年9月',
    desc: "雅集直觉杯入围金麦品质类大奖-生活百货类（电商界的奥斯卡）。"
  },
  {
    key: 2,
    time: '2017年12月',
    desc: "雅集圆满·功夫茶具套装，获“市长杯”分赛场铜奖。"
  },
  {
    key: 3,
    time: '2017年5月',
    desc: "雅集首次引进环保大豆油墨印刷技术，为保护环境做贡献。"
  },
  {
    key: 4,
    time: '2016年11月',
    desc: "雅集金兰杯，获“市长杯”总赛场铜奖。"
  },
  {
    key: 5,
    time: '2015年11月',
    desc: "雅集分享杯，获“市长杯”分赛场的铜奖；泡茶精灵则获产品组优秀奖。"
  },
  {
    key: 6,
    time: '2015年2月',
    desc: "雅集与上海木马工业产品设计有限公司合作设计产品。"
  },
  {
    key: 7,
    time: '2014年11月',
    desc: "雅集漫猫杯获“市长杯”大赛产品组优秀奖。"
  },
  {
    key: 8,
    time: '2014年4月',
    desc: "雅集首次联合市政府主办 “市长杯”大赛，自14年起不断携手国内外设计机构参与该活动并开发新品。"
  },
];

export const customizeExamples = [
  {
    title: '企业茶空间',
    data: [Enterprise1, Enterprise2, Enterprise3]
  },
  {
    title: '线下品牌店',
    data: [Offline1, Offline2, Offline3]
  },
  {
    title: '个人饮茶室',
    data: [PersonalDrinks1, PersonalDrinks2, PersonalDrinks3]
  },
]

export const caseShowList = [{
  key: 1,
  photo: Case1,
  title: '绅士杯'
}, {
  key: 2,
  photo: Case2,
  title: '水晶杯'
}, {
  key: 3,
  photo: Case3,
  title: '直觉杯'
}, {
  key: 4,
  photo: Case4,
  title: '漫猫杯铃铛款'
}, {
  key: 5,
  photo: Case5,
  title: '会议杯'
}, {
  key: 6,
  photo: Case6,
  title: '茶塔飘逸杯'
}]
